import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import PublicLayout from "web/components/PublicLayout";

import {
  Container
} from "web/pages/public/landing-page/LandingFooter/PrivacyPolicy/PrivacyPolicyStyled";
import LandingFooter from "..";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const PrivacyPolicy = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const websiteTerm = () => {
    history.push("/terms-of-use");
  };
  return (
    <>
      <Helmet title="PalletTrader | Privacy Policy">
        <meta name="description"
          content="Review PalletTrader’s privacy policy to learn how we collect, use, and protect your personal information while using our pallet marketplace." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/privacy-policy" />
      </Helmet>
      <PublicLayout transparentHeader={true}>
        <Container>
          <div>
            <h5 style={{ textAlign: "center" }}>
              <strong>Website Privacy Policy</strong>
            </h5>
            <p>Last modified: [August 01,2022]</p>
            <p>
              <strong>Introduction</strong>
            </p>
            <p>
              Delancey Street Pallet Traders LLC (&ldquo;
              <strong>PalletTrader</strong>&rdquo;&nbsp;or &ldquo;
              <strong>We</strong>&rdquo;) respects your privacy and is committed
              to protecting it through our compliance with this policy.
            </p>
            <p>
              This policy describes the types of information we may collect from
              you or that you may provide when you visit the website&nbsp;
              <strong>https://www.pallettrader.com</strong>&nbsp;(our &ldquo;
              <strong>Website</strong>&rdquo;) and our practices for collecting,
              using, maintaining, protecting, and disclosing that information.
            </p>
            <p>This policy applies to information we collect:</p>
            <ul>
              <li>
                <p>On this Website.</p>
              </li>
              <li>
                <p>
                  In email, text, and other electronic messages between you and
                  this Website.
                </p>
              </li>
              <li>
                <p>
                  &nbsp;When you interact with our advertising and applications on
                  third-party websites and services, if those applications or
                  advertising include links to this policy.
                </p>
              </li>
            </ul>
            <p>It does not apply to information collected by:</p>
            <ul>
              <li>
                <p>
                  Us offline or through any other means, including on any other
                  website operated by PalletTrader or any third party (including
                  our affiliates and subsidiaries); or&nbsp;
                </p>
              </li>
              <li>
                <p>
                  Any third party, including through any application or content
                  (including advertising) that may link to or be accessible from
                  or on the Website.
                </p>
              </li>
            </ul>
            <p>
              Please read this policy carefully to understand our policies and
              practices regarding your information and how we will treat it. If
              you do not agree with our policies and practices, your choice is not
              to use our Website. By accessing or using this Website, you agree to
              this privacy policy. This policy may change from time to time (see
              Changes to Our Privacy Policy). Your continued use of this Website
              after we make changes is deemed to be acceptance of those changes,
              so please check the policy periodically for updates.&nbsp;
            </p>
            <p>
              <strong>
                <u>Children Under the Age of 13</u>
              </strong>
            </p>
            <p>
              Our Website is not intended for children under 13 years of age. No
              one under age 13 may provide any information to or on the Website.
              We do not knowingly collect personal information from children under
              13. If you are under 13, do not use or provide any information on
              this Website, through any of its features, register on the Website,
              make any purchases or sales through the Website, use any of the
              interactive or public comment features of this Website, or provide
              any information about yourself to us, including your name, address,
              telephone number, email address, or any screen name or user name you
              may use. If we learn we have collected or received personal
              information from a child under 13 without verification of parental
              consent, we will delete that information. If you believe we might
              have any information from or about a child under 13, please contact
              us at 1-877-777-7495 or by email at support@pallettrader.com.
            </p>
            <p>
              <strong>
                <u>Information We Collect About You and How We Collect It</u>
              </strong>
            </p>
            <p>
              We collect several types of information from and about users of our
              Website, including information:
            </p>
            <ul>
              <li>
                <p>
                  By which you may be personally identified, such as name, postal
                  address, e-mail address, telephone number, driver&rsquo;s
                  license identification number, tax identification number, and
                  company website (&ldquo;<strong>personal information</strong>
                  &rdquo;); and&nbsp;
                </p>
              </li>
              <li>
                <p>
                  About your internet connection, the equipment you use to access
                  our Website, and usage details.
                </p>
              </li>
            </ul>
            <p>We collect this information:</p>
            <ul>
              <li>
                <p>Directly from you when you provide it to us.</p>
              </li>
              <li>
                <p>
                  Automatically as you navigate through the Website. Information
                  collected automatically may include usage details, IP addresses,
                  and information collected through cookies.
                </p>
              </li>
            </ul>
            <p>
              <em>Information You Provide to Us &nbsp;</em>
            </p>
            <p>
              The information we collect on or through our Website may include:
            </p>
            <ul>
              <li>
                <p>
                  Information that you provide by filling in forms on our Website.
                  This includes information provided at the time of applying for
                  membership on the PalletTrader platform, registering to use our
                  Website, subscribing to our service, posting material, or
                  requesting further services. We may also ask you for information
                  when you report a problem with our Website.
                </p>
              </li>
              <li>
                <p>
                  Records and copies of your correspondence (including email
                  addresses), if you contact us via support email, internal chat
                  functions or through claim resolution chats.
                </p>
              </li>
              <li>
                <p>
                  Details of transactions you carry out through our Website and of
                  the fulfillment of your orders. You may be required to provide
                  financial information to us or the payment entity that manages
                  payments on behalf of buyers and sellers on our Website before
                  placing an order through our Website.
                </p>
              </li>
              <li>
                <p>Your search queries on the Website.</p>
              </li>
              <li>
                <p>
                  Your bids or offers on any posts for pallets or other products
                  on the Website.&nbsp;
                </p>
              </li>
            </ul>
            <p>
              You also may provide information to be published or displayed
              (hereinafter, &ldquo;<strong>posted</strong>&rdquo;) on public areas
              of the Website, or transmitted to other users of the Website or
              third parties (collectively, &ldquo;
              <strong>User Contributions</strong>&rdquo;). Your User Contributions
              are posted on and transmitted to others at your own risk.
              &nbsp;Additionally, we cannot control the actions of other users of
              the Website with whom you may choose to share your User
              Contributions. Therefore, we cannot and do not guarantee that your
              User Contributions will not be viewed by unauthorized persons.
            </p>
            <p>
              Information We Collect Through Automatic Data Collection
              Technologies&nbsp;&nbsp;
            </p>
            <p>
              As you navigate through and interact with our Website, we may use
              automatic data collection technologies to collect certain
              information about your equipment, browsing actions, and patterns,
              including:
            </p>
            <ul>
              <li>
                <p>
                  &nbsp;Details of your visits to our Website, including traffic
                  data, location data, logs, and other communication data and the
                  resources that you access and use on the Website.
                </p>
              </li>
              <li>
                <p>
                  Information about your computer and internet connection,
                  including your IP address, operating system, and browser type.
                </p>
              </li>
            </ul>
            <p>
              The information we may collect automatically may include personal
              information or we may maintain it or associate it with personal
              information we collect in other ways or receive from third parties.
              It helps us to improve our Website and to deliver a better and more
              personalized service, including by enabling us to:
            </p>
            <ul>
              <li>
                <p>Estimate our audience size and usage patterns.</p>
              </li>
              <li>
                <p>
                  Store information about your preferences, allowing us to
                  customize our Website according to your individual interests.
                </p>
              </li>
              <li>
                <p>Speed up your searches.</p>
              </li>
              <li>
                <p>Recognize you when you return to our Website.</p>
              </li>
            </ul>
            <p>
              The technologies we use for this automatic data collection may
              include:
            </p>
            <ul>
              <li>
                <p>
                  <strong>Cookies (or browser cookies).</strong>&nbsp;A cookie is
                  a small file placed on the hard drive of your computer. You may
                  refuse to accept browser cookies by activating the appropriate
                  setting on your browser. However, if you select this setting you
                  may be unable to access certain parts of our Website. Unless you
                  have adjusted your browser setting so that it will refuse
                  cookies, our system will issue cookies when you direct your
                  browser to our Website.&nbsp;
                </p>
              </li>
              <li>
                <p>
                  <strong>Flash Cookies.</strong>&nbsp;Certain features of our
                  Website may use local stored objects (or Flash cookies) to
                  collect and store information about your preferences and
                  navigation to, from, and on our Website. Flash cookies are not
                  managed by the same browser settings as are used for browser
                  cookies. For information about managing your privacy and
                  security settings for Flash cookies, see Choices About How We
                  Use and Disclose Your Information.
                </p>
              </li>
            </ul>
            <p>
              <strong>
                <u>Google Analytics</u>
              </strong>
            </p>
            <p>
              The Website has integrated Google Analytics. &nbsp;Google Analytics
              is a website analysis service. &nbsp;Website analysis refers to
              collection, recording and analysis of data regarding the behavior of
              visitors to a website. &nbsp;A website analysis service records data
              showing, among other things, from which website a visitor has come,
              which pages of the website were accessed and how often and for how
              long a page was viewed. &nbsp;Website analysis is used mainly for
              the optimization of a website and for a cost-benefit analysis of
              internet advertising. &nbsp;Google Analytics uses cookies.
              &nbsp;Information regarding the privacy policies of Google may be
              found at&nbsp;<strong>https://policies.google.com/</strong>
            </p>
            <p>
              <strong>
                <u>Third-Party Use of Cookies and Other Tracking Technologies</u>
              </strong>
            </p>
            <p>
              Some content or applications, including advertisements, on the
              Website are served by third-parties, including advertisers, ad
              networks and servers, content providers, and application providers.
              These third parties may use cookies alone or in conjunction with
              other tracking technologies to collect information about you when
              you use our Website. The information they collect may be associated
              with your personal information or they may collect information,
              including personal information, about your online activities over
              time and across different websites and other online services. They
              may use this information to provide you with interest-based
              (behavioral) advertising or other targeted content.&nbsp;
            </p>
            <p>
              We do not control these third parties&rsquo; tracking technologies
              or how they may be used. If you have any questions about an
              advertisement or other targeted content, you should contact the
              responsible provider directly. For information about how you can opt
              out of receiving targeted advertising from many providers, see{" "}
              <a href="https://docs.google.com/document/d/14JxW02vYEqTWvBujVcYVIxZ_ZaJn5Aa8/edit#bookmark=id.2s8eyo1">
                Choices About How We Use and Disclose Your Information
              </a>
              .
            </p>
            <p>
              <strong>
                <u>How We Use Your Information</u>
              </strong>
            </p>
            <p>
              We use information that we collect about you or that you provide to
              us, including any personal information:
            </p>
            <ul>
              <li>
                <p>To present our Website and its contents to you.</p>
              </li>
              <li>
                <p>
                  To provide you with information, products, or services that you
                  request from us.
                </p>
              </li>
              <li>
                <p>To fulfill any other purpose for which you provide it.</p>
              </li>
              <li>
                <p>
                  To provide you with notices about your membership in the
                  PalletTrader platform, including expiration and renewal notices.
                </p>
              </li>
              <li>
                <p>
                  To carry out our obligations and enforce our rights arising from
                  any contracts entered into between you and us, including for
                  billing and collection.
                </p>
              </li>
              <li>
                <p>
                  To notify you about changes to our Website or any products or
                  services we offer or provide though it.
                </p>
              </li>
              <li>
                <p>
                  To allow you to participate in interactive features on our
                  Website.
                </p>
              </li>
              <li>
                <p>
                  In any other way we may describe when you provide the
                  information.
                </p>
              </li>
              <li>
                <p>For any other purpose with your consent.</p>
              </li>
            </ul>
            <p>
              We may also use your information to contact you about our own or our
              affiliates&rsquo; goods and services that may be of interest to you.
              If you do not want us to use your information in this way, you may
              choose to unsubscribe. &nbsp;For more information, see Choices About
              How We Use and Disclose Your Information.
            </p>
            <p>
              <strong>
                <u>Disclosure to Payment Entity</u>
              </strong>
            </p>
            <p>
              A designated entity (the &ldquo;<strong>Payment Entity</strong>
              &rdquo;) manages payments on behalf of buyers and sellers on the
              Website. &nbsp;Certain personal information will be disclosed to the
              Payment Entity in order for you to engage in transactions on the
              Website. The payment Entity is currently Stripe, Inc. &nbsp;The
              Payment Entity&rsquo;s privacy policy is set forth at&nbsp;
              <a href="https://stripe.com/privacy">
                <strong>https://stripe.com/privacy</strong>
              </a>{" "}
              . PalletTrader is not responsible for the Payment Entity adhering to
              the Payment Entity&rsquo;s privacy policy.
            </p>
            <p>
              <u>
                <strong>Other Disclosures of Your Information</strong>
              </u>
            </p>
            <p>
              We may disclose aggregated information about our users, and
              information that does not identify any individual, without
              restriction.&nbsp;
            </p>
            <p>
              We may disclose personal information that we collect or you provide
              as described in this privacy policy:
            </p>
            <ul>
              <li>
                <p>To our subsidiaries and affiliates.</p>
              </li>
              <li>
                <p>
                  To contractors, service providers, and other third parties we
                  use to support our business.
                </p>
              </li>
              <li>
                <p>
                  To a buyer or other successor in the event of a merger,
                  divestiture, restructuring, reorganization, dissolution, or
                  other sale or transfer of some or all of our assets, whether as
                  a going concern or as part of bankruptcy, liquidation, or
                  similar proceeding, in which personal information held by us
                  about our Website users is among the assets transferred.
                </p>
              </li>
              <li>
                <p>To fulfill the purpose for which you provide it.&nbsp;</p>
              </li>
              <li>
                <p>
                  For any other purpose disclosed by us when you provide the
                  information.
                </p>
              </li>
              <li>
                <p>With your consent.</p>
              </li>
            </ul>
            <p>We may also disclose your personal information:</p>
            <ul>
              <li>
                <p>
                  To comply with any court order, law, or legal process, including
                  to respond to any government or regulatory request.
                </p>
              </li>
              <li>
                <p>
                  To enforce or apply our{" "}
                  <span onClick={websiteTerm} className="link-url">
                    terms of use
                  </span>{" "}
                  or terms and conditions for buyers and sellers is readily
                  available for the user upon the login to website under
                  Operations T&amp;C and other agreements, including for billing
                  and collection purposes.
                </p>
              </li>
              <li>
                <p>
                  If we believe disclosure is necessary or appropriate to protect
                  the rights, property, or safety of Delancey Street Pallet
                  Traders LLC, our customers, or others. This includes exchanging
                  information with other companies and organizations for the
                  purposes of fraud protection and credit risk reduction.
                </p>
              </li>
            </ul>
            <p>
              <strong>
                <u>Choices About How We Use and Disclose Your Information</u>
              </strong>
            </p>
            <p>
              We strive to provide you with choices regarding the personal
              information you provide to us. We have created mechanisms to provide
              you with the following control over your information:&nbsp;
            </p>
            <ul>
              <li>
                <p>
                  <strong>Tracking Technologies and Advertising.</strong>&nbsp;You
                  can set your browser to refuse all or some browser cookies, or
                  to alert you when cookies are being sent. If you disable or
                  refuse cookies, please note that some parts of the Website may
                  then be inaccessible or not function properly.
                </p>
              </li>
              <li>
                <p>
                  <strong>
                    Disclosure of Your Information for Third-Party Advertising
                  </strong>
                  .&nbsp;If you do not want us to share your personal information
                  with unaffiliated or non-agent third parties for promotional
                  purposes, you can choose to unsubscribe.&nbsp;
                </p>
              </li>
              <li>
                <p>
                  <strong>Promotional Offers from the PalletTrader.</strong>
                  &nbsp;If you do not wish to have your email address used by
                  PalletTrader to promote our own or third parties&rsquo; products
                  or services, you can opt-out by choosing to unsubscribe.
                </p>
              </li>
              <li>
                <p>
                  <strong>Targeted Advertising.</strong>&nbsp;If you do not want
                  us to use information that we collect or that you provide to us
                  to deliver advertisements according to our advertisers&rsquo;
                  target-audience preferences, you can opt-out by choosing to
                  unsubscribe.&nbsp;
                </p>
              </li>
            </ul>
            <p>
              We do not control third parties&rsquo; collection or use of your
              information to serve interest-based advertising. However these third
              parties may provide you with ways to choose not to have your
              information collected or used in this way. You can opt out of
              receiving targeted ads from members of the Network Advertising
              Initiative (&ldquo;<strong>NAI</strong>&rdquo;) on the NAI&rsquo;s
              website.
            </p>
            <p>
              <strong>
                <u>Accessing and Correcting Your Information</u>
              </strong>
            </p>
            <p>
              You can review and change your personal information by contacting
              PalletTrader support at 1-877-777-7495, or emailing
              support@pallettrader.com.&nbsp;
            </p>
            <p>
              If you delete your User Contributions from the Website, copies of
              your User Contributions may remain viewable in cached and archived
              pages, or might have been copied or stored by other Website users.
              &nbsp;Proper access and use of information provided on the Website,
              including User Contributions, is governed by our{" "}
              <span onClick={websiteTerm} className="link-url">
                terms of use
              </span>
              .
            </p>
            <p>
              <strong>
                <u>Data Security</u>
              </strong>
            </p>
            <p>
              We have implemented measures designed to secure your personal
              information from accidental loss and from unauthorized access, use,
              alteration, and disclosure. All information you provide to us is
              stored on secure servers behind firewalls. Any payment transactions
              will be encrypted.
            </p>
            <p>
              The safety and security of your information also depends on you.
              Where we have given you (or where you have chosen) a password for
              access to certain parts of our Website, you are responsible for
              keeping this password confidential. We ask you not to share your
              password with anyone. We urge you to be careful about giving out
              information in public areas of the Website like message boards. The
              information you share in public areas may be viewed by any user of
              the Website.
            </p>
            <p>
              Unfortunately, the transmission of information via the internet is
              not completely secure. Although we do our best to protect your
              personal information, we cannot guarantee the security of your
              personal information transmitted to our Website. Any transmission of
              personal information is at your own risk. We are not responsible for
              circumvention of any privacy settings or security measures contained
              on the Website.&nbsp;
            </p>
            <p>
              <u>
                <strong>Changes to Our Privacy Policy</strong>
              </u>
            </p>
            <p>
              It is our policy to post any changes we make to our privacy policy
              on this page with a notice that the privacy policy has been updated
              on the Website home page. If we make material changes to how we
              treat our users&rsquo; personal information, we will notify you
              through a notice on the Website home page. The date the privacy
              policy was last revised is identified at the top of the page. You
              are responsible for periodically visiting our Website and this
              privacy policy to check for any changes.
            </p>
            <p>
              <strong>
                <u>Contact Information</u>
              </strong>
            </p>
            <p>
              To ask questions or comment about this privacy policy and our
              privacy practices, contact us at: &nbsp;
              <a href="mailto:support@pallettrader.com">
                support@pallettrader.com
              </a>
              , or via our toll-free number: &nbsp;1-877-777-7495.
            </p>
            <p>&nbsp;</p>
          </div>
        </Container>
        <LandingFooter isBackgroundWhite={true} />
      </PublicLayout>
    </>
  );
};

export default PrivacyPolicy;
